import Login from '@/containers/login/Login';
import Phone from '@/containers/login/Phone';
import Guide from '@/containers/login/Guide';

import { ROUTE_LOGIN, ROUTE_LOGIN_GUIDE, ROUTE_LOGIN_PHONE } from './names';


export default [
    {
        path: '/login',
        name: ROUTE_LOGIN,
        component: Login,
        meta: {
            title: '登录',
            bridge: true,
        },
    },
    {
        path: '/login/phone',
        name: ROUTE_LOGIN_PHONE,
        component: Phone,
        meta: {
            title: '手机登录',
        },
    },
    {
        path: '/login/guide',
        name: ROUTE_LOGIN_GUIDE,
        component: Guide,
        meta: {
            auth: true,
            title: '首次使用设置',
        },
    },
];



// WEBPACK FOOTER //
// ./src/router/login.js